<template>
    <v-container fluid class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.teamBuilding.participants') }}
        </div>

        <participant-list-view
            class="participant-list-view"
            :participants="participants"
            :pagination="pagination"
        />

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotalVisible"
            @input="onPaginationChanged"
        />
    </v-container>
</template>

<script>
import ParticipantListView from '@/views/ParticipantListView'
import { getParticipants } from '@/services/mock'

export default {
    name: 'ParticipantListPage',

    components: {
        ParticipantListView
    },

    data () {
        return {
            participants: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 1,
                itemsPerPage: 50,
                search: '',
                customerGroup: 'All Customer',
                dateRange: []
            }
        }
    },

    mounted () {
        this.getMockData()
    },

    methods: {
        getMockData () {
            this.participants = getParticipants()
        },

        onPaginationChanged () {}
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
